import { render, staticRenderFns } from "./ProjectProfitForecast.vue?vue&type=template&id=4730e2e0&"
import script from "./ProjectProfitForecast.vue?vue&type=script&lang=js&"
export * from "./ProjectProfitForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports